import { useTranslation } from 'react-i18next';
import FloatingShapes from "../common/FloatingShapes";

const posts = [
  {
    id: 1,
    title: "\u201cЭко баатрууд\u201d Байгаль танин мэдэхүй, гадаад орчин",
    href: "#",
    description:
      `Байгаль миний найз
      / Хог-Алт
      / Ургамлын хаан
      / Тэнгэрийн зааг
      / Уяа зангилаа
      / Уулын дугуйтай аялал
      / Байгаль танин мэдэхүйн явган аялал
      / Уулын таг
      / Амьдын ертөнц
      / 100 жилийн амьдрал
      / Байгалийн дуран
      `,
    imageUrl: "/baigali.png",
  },
  {
    id: 2,
    title: "\u201cМонголчуудын бахархал\u201d Зан заншил, өв соёл, уламжлал",
    href: "#",
    description:
      `Миний нутаг
      / Эх хэлний баялаг
      / Монгол гэр
      / Тоглоом, наадгай
      / Төрийн бэлгэдэл
      / Морин хуур
      / Бие биелэгээ
      / Нум сум харвах
      / Монгол ахуй
      / Ардын урлаг
      / Өв тээгчид
      `,
    imageUrl: "/zan-zanshil.png",
  },
  {
    id: 3,
    title: "\u201cХамтдаа бүтээцгээе\u201d Амьдрах ухаан, бүтээлч сэтгэлгээ ",
    href: "#",
    description:
      `Керамик урлал
      / Шүрэн урлал
      / Утсан зангилаа
      / Модон урлал
      / Арьсан урлал
      / Чулууны инээмсэглэл
      / Санхүүгийн боловсрол
      / Техник сэтгэлгээ
      / Лего-"Шимт боловсрол"
      `,
    imageUrl: "/amidrah.png",
  },
  {
    id: 4,
    title: "\u201cБи хэн бэ?\u201d Хувь хүний чадвар, хөгжил, оролцоо ",
    href: "#",
    description:
      `Ой тогтоолт
      / Мэдрэмжийн хөгжил
      / Сахилга, дэг журам
      / Эрүүл мэнд нөхөн үржихүй
      / Харилцааны баялаг-хандлагын боловсрол
      / Цаг баримтлал
      / 5S
      / Зөв дадал-Зөв хүүхэд
      / Хууль-Бидний амьдралд
      `,
    imageUrl: "/huwi-hun.png",
  },
  {
    id: 5,
    title: "\u201cБид авьяастай\u201d Соёл урлаг, спорт ",
    href: "#",
    description:
      `Кино боловсрол
      / Хэмнэл
      / Бүжиг (Чөлөөт, цэнгээнт)
      / Найрамдал медиа
      / Спорт өрөлт
      / Кендама
      / Крикет
      / Райгби
      / Гар бөмбөг
      / Сагсан бөмбөг
      / Хөл бөмбөг
      `,
    imageUrl: "/soyl.png",
  },
];

export default function Program() {
  const { t } = useTranslation();

  return (
    <>
      {/* Dark hero */}
      <div className="relative overflow-hidden bg-primary-800 -mt-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-secondary-500/15 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-secondary-400/10 blur-[100px]" />
          <div className="absolute bottom-20 right-1/4 w-[250px] h-[250px] rounded-full bg-accent-500/10 blur-[80px]" />
        </div>
        <FloatingShapes variant="default" />
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
          }}
        />
        <div className="relative pt-40 pb-16 sm:pt-48 sm:pb-20">
          <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-secondary-300 backdrop-blur-sm">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-secondary-400 animate-pulse" />
              {t('program.badge')}
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight">
              <span className="bg-gradient-to-r from-secondary-400 to-accent-400 bg-clip-text text-transparent">{t('program.title')}</span>
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-slate-400 max-w-3xl mx-auto leading-relaxed">
              {t('program.description')}
            </p>
          </div>
        </div>
      </div>

      {/* Content section */}
      <div className="bg-neutral-50 py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="space-y-12">
            {posts.map((post, index) => (
              <article
                key={post.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 overflow-hidden animate-slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex flex-col lg:flex-row">
                  <div className="relative lg:w-80 lg:shrink-0 overflow-hidden group/image">
                    <img
                      src={post.imageUrl}
                      alt={post.title}
                      className="w-full h-64 lg:h-full object-cover group-hover/image:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <div className={`w-14 h-14 rounded-2xl bg-gradient-to-r ${index % 2 === 0 ? 'from-secondary-500 to-secondary-600' : 'from-accent-500 to-accent-600'} flex items-center justify-center shadow-lg`}>
                        <span className="text-white font-bold text-lg">{String(index + 1).padStart(2, '0')}</span>
                      </div>
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover/image:opacity-100 transition-opacity"></div>
                  </div>
                  <div className="flex-1 p-8 lg:p-10">
                    <h3 className="text-2xl sm:text-3xl font-bold leading-6 text-neutral-900 mb-6 group-hover:text-secondary-600 transition-colors">
                      {post.title}
                    </h3>
                    <div className="grid sm:grid-cols-2 gap-3">
                      {post.description.split("/").filter(item => item.trim()).map((item, idx) => (
                        <div
                          key={idx}
                          className="flex items-center gap-2 bg-secondary-50 rounded-lg px-4 py-2"
                        >
                          <span className="text-secondary-600 font-bold">•</span>
                          <span className="text-neutral-700 font-medium">{item.trim()}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
